import { render } from "./Detail.vue?vue&type=template&id=1602a11c&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=1602a11c&scoped=true&lang=css"
import "./Detail.vue?vue&type=style&index=1&id=1602a11c&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1602a11c"]])

export default __exports__